module.exports = __webpack_public_path__ + "img/support_e7.15235bb3.png";